import { useUserPermissions } from '../../../pages/company/userPermissions'

export const useCanEditInventory = (): boolean => {
  const { edit } = useUserPermissions()
  return edit
}
